// Repas — source unique de vérité pour l'ordre et les libellés.
import type { Meal } from './types';

// Ordre d'affichage canonique.
export const MEAL_ORDER: Meal[] = ['breakfast', 'lunch', 'dinner', 'snack'];

export const MEAL_LABELS: Record<Meal, string> = {
  breakfast: 'Petit-déjeuner',
  lunch: 'Déjeuner',
  dinner: 'Dîner',
  snack: 'Collation',
};

// Libellés courts (graphes compacts).
export const MEAL_SHORT_LABELS: Record<Meal, string> = {
  breakfast: 'Petit-déj',
  lunch: 'Déjeuner',
  dinner: 'Dîner',
  snack: 'Collation',
};
